@import frontend/shared/stylesheets/environment

.huge-notification-desktop
  position: relative
  padding: 40px 40px 40px 0

  background: #fff

  font-size: 16px

  height: auto
  max-height: calc(100vh - 100px)
  transition: height .3s ease-out
  interpolate-size: allow-keywords

  &.-mod-grown
    overflow-y: auto

  +media-breakpoint-down(lg)
    display: none

  +if-ab-test(adblock_allowlisting, b)
    display: none

.huge-notification-desktop--layout
  display: flex

.huge-notification-desktop--image-col
  position: relative
  flex: 0 0 16.666%

  .huge-notification-desktop.-mod-on-step-2-safari &,
  .huge-notification-desktop.-mod-on-step-2-non-safari &
    display: none

.huge-notification-desktop--text-col
  flex: 1
  min-width: 0
  padding: 0 15px

  .huge-notification-desktop.-mod-on-step-2-safari &,
  .huge-notification-desktop.-mod-on-step-2-non-safari &
    padding: 0 0 0 40px

.huge-notification-desktop--body
  overflow-y: hidden

.huge-notification-desktop--image
  position: absolute
  top: 0
  left: 40px
  right: -40px
  bottom: 0

  content: ''
  display: block

  background: url('frontend/shared/images/huge_notification/huge_notification_a.webp') no-repeat center bottom
  background-size: contain

.huge-notification-desktop--button
  margin-top: 4px

.huge-notification-desktop--divider
  margin: 24px 0
  border: none
  border-top: 1px solid $theme-platinum

.huge-notification-desktop--recheck
  display: flex
  align-items: center
  gap: 16px

.huge-notification-desktop--headline
  font-size: 26px
  font-weight: bold

.huge-notification-desktop--steps
  display: flex
  flex-direction: column
  gap: 40px
  margin-top: 40px

.huge-notification-desktop--step-item
  display: flex
  flex-direction: column
  gap: 20px
  align-items: flex-start

  img
    max-width: 100%

.huge-notification-desktop--step
  &.-mod-step-1
    .huge-notification-desktop:not(.-mod-on-step-1) &
      display: none
  &.-mod-step-2-safari
    .huge-notification-desktop:not(.-mod-on-step-2-safari) &
      display: none
  &.-mod-step-2-non-safari
    .huge-notification-desktop:not(.-mod-on-step-2-non-safari) &
      display: none

.huge-notification-desktop--instruction
  display: flex
  align-items: center
  gap: 1rem

.huge-notification-desktop--instruction-number
  height: 38px
  width: 38px
  font-size: 14px
  line-height: 38px
  text-align: center
  background-color: $theme-gray
  border-radius: 999px
